import { SET_USER_PROFILE } from '../actions/type';

const initState = {
    nextCycleDate: '',
    recurringStatus: '',
    packageType: '',
    expireDate: '',
    currentPackage: {},
    displayname: '',
    avatar: ''
}

const userProfileHistory = (state = initState, action) => {
    switch (action.type) {
        case SET_USER_PROFILE:
            const payload = action.payload;
            return { ...state, ...payload };
        default:
            return state;
    }
}

export default userProfileHistory